// extracted by mini-css-extract-plugin
export var callCard = "_md-0";
export var callMessageButton = "_md-1";
export var helpIcon = "_md-3";
export var helpIconContainer = "_md-4";
export var verticalDivider = "_md-2";